import React, { FC, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ROUTES } from "../../../routes/routes"; // Ensure this imports correctly
import { useAppContext } from "../../../context/AppContext";
import { useSelector } from "react-redux";

// Helper function to get the page title based on the route
const getPageTitle = (pathname: string, orderCode?: string) => {
  // Match routes with dynamic parameters like :categoryId or :orderId
  const dynamicRouteMatch = (route: string, path: string) => {
    const routeSegments = route.split("/");
    const pathSegments = path.split("/");

    if (routeSegments.length !== pathSegments.length) {
      return false;
    }

    for (let i = 0; i < routeSegments.length; i++) {
      // Allow matching dynamic segments (like :orderId)
      if (routeSegments[i].startsWith(":")) {
        continue;
      }

      if (routeSegments[i] !== pathSegments[i]) {
        return false;
      }
    }
    return true;
  };

  // Extract dynamic segments from the pathname
  const extractDynamicSegment = (path: string, baseRoute: string) => {
    const pathSegments = path.split("/");
    const baseSegments = baseRoute.split("/");

    for (let i = 0; i < baseSegments.length; i++) {
      if (baseSegments[i].startsWith(":")) {
        return pathSegments[i]; // Return the dynamic segment
      }
    }
    return null;
  };

  // Check if path matches any static or dynamic route
  switch (pathname) {
    case ROUTES.HOME:
      return "Home";
    case ROUTES.PRODUCTS:
      return "Products";
    case ROUTES.ADD_ARTICLE:
      return "Add New Article";
    case ROUTES.ARTICLES:
      return "Articles";
    case ROUTES.ADD_PRODUCT:
      return "Add New Product";
    case ROUTES.ADD_BANNER:
      return "Add Banners";
    case ROUTES.EDIT_PRODUCT:
      return "Edit Product";
    case ROUTES.CATEGORIES:
      return "Categories";
    case ROUTES.ADD_CATEGORY:
      return "Add New Category";
    case ROUTES.EDIT_CATEGORY:
      return "Edit Category";
    case ROUTES.BRANDS:
      return "Brands";
    case ROUTES.ADD_BRAND:
      return "Add New Brand";
    case ROUTES.USER:
      return "Users";
    case ROUTES.ADD_USER:
      return "Add New User";
    case ROUTES.EDIT_BRAND:
      return "Edit Brand";
    case ROUTES.ORDERS:
      return "Orders";
    case ROUTES.OFFERS:
      return "Offers";
    case ROUTES.TAGS:
      return "Tags";
    case ROUTES.ADMINS:
      return "Admins";
    case ROUTES.MY_PROFILE:
      return "My Profile";
    case ROUTES.ADDADMINS:
      return "Add New Admin";
    case ROUTES.ADD_OFFERS:
      return "Add New Offer";
    case ROUTES.FORGOT_PASSWORD:
      return "Forgot Password";
    case ROUTES.RESET_PASSWORD:
      return "Reset Password";
    case ROUTES.LOGIN:
      return "Login";
    default:
      // Check for dynamic routes
      for (const route of Object.values(ROUTES)) {
        if (dynamicRouteMatch(route, pathname)) {
          // Handle category and product dynamic routes
          if (route.includes('categories')) {
            if (route.includes('edit')) {
              return 'Edit Category'; // For /categories/edit/:categoryId
            }
          }
          if (route.includes('brands')) {
            if (route.includes('edit')) {
              return 'Edit Brand'; // For /categories/edit/:categoryId
            }
          }
          if (route.includes('products')) {
            if (route.includes('edit')) {
              return 'Edit Product'; // For /products/edit/:productId
            }
            if (route.includes('add-new-product')) {
              return 'Add New Product'; // For /products/add-new-product
            }
          }
          if (route.includes("orders") && orderCode) {
            return `Order - ${orderCode}`; // Dynamic title
          }
        }

       
      }
      return "Page Not Found";
  }
};

export const PageTitle: FC<{}> = () => {
  const { title, updateTitle } = useAppContext();
  
  const oneOrderData = useSelector((state: any) => state.rootReducer.orderDetail.oneOrderData);
  const location = useLocation();

  useEffect(() => {
    const orderCode = oneOrderData?.data?.orderCode; // Extract orderCode from state
    const newTitle = getPageTitle(location.pathname, orderCode); // Pass orderCode to the helper
    updateTitle([{ path: location.pathname, label: newTitle }]); // Update the context with the new title
  }, [location.pathname, oneOrderData]);

  return (
    <h1 className="flex mxs:text-2xl text-lg whitespace-pre">
      {title[0]?.label}
    </h1>
  );
};

export default PageTitle;
